import { forwardRef } from 'react';
import flattenChildren from 'react-keyed-flatten-children';
import styled, { css } from 'styled-components';
import { parseAlignProp } from "../props/AlignProps.js";
import { useResponsiveProp } from "../props/ResponsiveProp.js";
import { parseSpaceProp } from "../props/SpaceProp.js";
import { jsx as _jsx } from "react/jsx-runtime";
function inlineRootMixin(spaceProp, noWrap, verticalAlign, horizontalAlign) {
  var space = parseSpaceProp(spaceProp);
  return css(["&:before{margin-top:", "px;}& > div{display:flex;margin-left:-", "px;flex-wrap:", ";align-items:", ";justify-content:", ";& > div{&:empty{display:none;}min-width:0;flex-shrink:0;max-width:100%;margin-top:", "px;margin-left:", "px;}}"], -space - 1, space, noWrap ? 'nowrap' : 'wrap', parseAlignProp(verticalAlign), parseAlignProp(horizontalAlign), space, space);
}
var InlineRoot = /*#__PURE__*/styled.div.withConfig({
  displayName: "Inline__InlineRoot",
  componentId: "SD__sc-13du4wm-0"
})(_ref => {
  var {
    theme,
    space,
    noWrap,
    verticalAlign,
    horizontalAlign
  } = _ref;
  return css(["padding-top:1px;&:before{content:'';display:block;}", " ", "{", "}", "{", "}"], inlineRootMixin(space[0], noWrap[0], verticalAlign[0], horizontalAlign[0]), theme.breakpoints.up('sm'), inlineRootMixin(space[1], noWrap[1], verticalAlign[1], horizontalAlign[1]), theme.breakpoints.up('md'), inlineRootMixin(space[2], noWrap[2], verticalAlign[2], horizontalAlign[2]));
});
export var Inline = /*#__PURE__*/forwardRef((_ref2, ref) => {
  var {
    children,
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledBy,
    noWrap: noWrapProp = false,
    space: spaceProp = 'xsmall',
    verticalAlign: verticalAlignProp = 'top',
    horizontalAlign: horizontalAlignProp = 'left'
  } = _ref2;
  var space = useResponsiveProp(spaceProp);
  var noWrap = useResponsiveProp(noWrapProp);
  var verticalAlign = useResponsiveProp(verticalAlignProp);
  var horizontalAlign = useResponsiveProp(horizontalAlignProp);
  return /*#__PURE__*/_jsx(InlineRoot, {
    ref: ref,
    space: space,
    noWrap: noWrap,
    verticalAlign: verticalAlign,
    horizontalAlign: horizontalAlign,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    children: /*#__PURE__*/_jsx("div", {
      children: flattenChildren(children).map((child, idx) => /*#__PURE__*/_jsx("div", {
        children: child
      }, idx))
    })
  });
});
if (process.env.NODE_ENV !== "production") Inline.displayName = "Inline";